import { createSelector, createFeatureSelector } from '@ngrx/store';
import { PaymentSettingsState } from './payment-settings.reducer';

// Seleciona o estado das configurações de pagamento
export const selectPaymentSettingsState =
  createFeatureSelector<PaymentSettingsState>('paymentSettings');

// Seleciona todas as configurações de pagamento
export const selectAllPaymentSettings = createSelector(
  selectPaymentSettingsState,
  (state: PaymentSettingsState) => state.paymentSettings
);

// Seleciona o estado de erro
export const selectPaymentSettingsError = createSelector(
  selectPaymentSettingsState,
  (state: PaymentSettingsState) => state.error
);

export const selectPaymentSettingsCurrent = createSelector(
  selectPaymentSettingsState,
  (state: PaymentSettingsState) => state.paymentSettingsCurrent
);

export const selectPaymentSettingsCurrentLoading = createSelector(
  selectPaymentSettingsState,
  (state: PaymentSettingsState) => state.isLoading
);
